export default function() {
    let _this = this;
     if(!this.DEBUG){
        if(!window.console) window.console = {};
        var methods = ["log", "debug", "warn", "info"];
        for(var i=0;i<methods.length;i++){
            console[methods[i]] = function(){};
        }
    }

     window.addEventListener("dsb-pwa-base_update", e => {
        if('detail' in e)
        {
            let update = e.detail;
            if('appname' in update)
            {
              if(document.getElementById('dsb-pwa_appname')){
                document.getElementById("dsb-pwa_appname").innerHTML = update.appname;
              }
            }
            if('app_tab_title' in update)
            {
              _this._app_tab_title = update.app_tab_title;
              _this._update_DocumentTitle();
            }
            if('title' in update)
            {
              if(document.getElementById('dsb-pwa_title')){
                document.getElementById("dsb-pwa_title").innerHTML = update.title;
              }
            }
            if('layout' in update)
            {
              _this.setAttribute(`layout`, update.layout);
              _this._render();
            }
        }
     });

     window.addEventListener("dsb-pwa-transient_aside", e => {
        try
        {
          if('detail' in e)
          {
            if('iam' in e.detail)
            {
              if(typeof e.detail.iam == 'object' && e.detail.iam instanceof HTMLElement)
              {
                // OK
              }
              else
              {
                console.error(e.detail.iam instanceof HTMLElement,e.detail.iam.constructor.name,e.detail.iam);
                throw "e.detail.iam should be instanceof HTMLElement";
              }
            }
            else
            {
              throw "e.detail.iam missing and should be instanceof HTMLElement";
            }

            let workspace = window.getWorkspace(e.detail.iam);

            if(workspace == null || typeof workspace !== 'object')
            {
              throw 'Missing workspace!';
            }

            var this_aside = document.createElement("aside");
            this_aside.classList.add('general_aside_fw_workbench');
            this_aside.classList.add('right');
            var this_aside_body = document.createElement("div");
            this_aside_body.style="margin-top:10px;";
            if('name' in e.detail)
            {
              this_aside.id = e.detail.name;
            }
            else
            {
              throw 'Missing '+e.detail.name;
            }

            var this_aside_title = document.createElement("h3");
            this_aside_title.classList.add('m-icon-right');
            this_aside_title.style='position: fixed; width: 100%;';
            this_aside.append(this_aside_title);

            if('body' in e.detail)
            {
              if(typeof e.detail.body == 'object' && e.detail.body instanceof HTMLElement)
              {
                this_aside_body.append(e.detail.body);
              }
              else
              {
                this_aside_body.innerHTML = e.detail.body;
              }
            }
            else
            {
              throw 'Missing '+e.detail.name;
            }

            this_aside.append(this_aside_body);

            e.detail.iam.fw_workbench__closeOptions=function(){
              e.detail.iam.classList.toggle('active');
              this_aside.classList.toggle('show');
              if(workspace !== null || typeof workspace == 'object')
              {
                workspace.querySelector('.dsb-workspace-overlay').classList.toggle('show');
              }
              setTimeout(function() {
                  this_aside.remove();
                  delete e.detail.iam.fw_workbench__closeOptions;
              }, 500);
            }

            //let this_aside_close = document.createElement("span");
            //this_aside_close.classList='m-icon-close';
            //this_aside_close.style="position:absolute;top:5px;right:5px;display:inline-block;";
            this_aside_title.onclick=function(){
              e.detail.iam.fw_workbench__closeOptions();
            }
            //this_aside.append(this_aside_close);

            if('parentNode' in workspace)
            {
              workspace.parentNode.append(this_aside);
            }

             setTimeout(function() {
                e.detail.iam.classList.toggle('active');
                this_aside.classList.toggle('show');
              }, 100);

            workspace.querySelector('.dsb-workspace-overlay').onclick=function(){
              this_aside_title.click();
            };
            workspace.querySelector('.dsb-workspace-overlay').classList.toggle('show');

          }
          else
          {
            console.error('dsb-pwa-append_tray:: Missing any detail',e);
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-append_tray:: Error occured in detail',ex,e);
        }
     });

     window.addEventListener("dsb-pwa-append_tray", e => {
        try
        {
          if('detail' in e)
          {
            let tray_id = 'dsb-pwa_tray';
            if(('tray_id' in e.detail))
            {
              tray_id = e.detail.tray_id;
            }
            else if('iam' in e.detail)
            {
              if(typeof e.detail.iam == 'object' && e.detail.iam instanceof HTMLElement)
              {
                if('tray_selector' in e.detail)
                {
                  tray_id = window.getTrayId(e.detail.iam,e.detail.tray_selector);
                }
                else
                {
                  tray_id = window.getTrayId(e.detail.iam);
                }
              }
              else
              {
                throw "e.detail.iam should be instanceof HTMLElement";
              }
            }

            let workspace = window.getWorkspace(document.getElementById(tray_id));

            if(workspace == null || typeof workspace !== 'object')
            {
              throw 'Missing workspace!';
            }

            if(('init_append' in e.detail) && 'parentNode' in workspace)
            {
              workspace.parentNode.append(e.detail.init_append);
            }

            let element = document.createElement('div');
            if('name' in e.detail)
            {
              element.id = tray_id+'__'+e.detail.name;
            }

            let dom_insertion = 'prepend';
            if('dom_insertion' in e.detail)
            {
              dom_insertion = e.detail.dom_insertion;
            }

            if(('online_only' in e.detail) && e.detail.online_only === true)
            {
              // If online only the item wil have click events removed and dissabled class added
              element.classList.add('fw_workspace__online_only');
              element.setAttribute('data-offlineonly_toggleClass','dissable-icon');
            }

            if(('onclick' in e.detail) && ('icon' in e.detail))
            {
              element.setAttribute('class',e.detail.icon+' icon-clickable');
              element.onclick = function(){e.detail.onclick};

              if('icon_size' in e.detail)
              {
                element.setAttribute('style','margin-left: 0px;font-size: '+e.detail.icon_size+';');
              }
              else
              {
                element.setAttribute('style','margin-left: 0px;font-size: 30px;');
              }
              if(('overlay' in e.detail) && (e.detail.overlay))
              {
                element.onclick = function(){
                  if(!this.classList.contains('active'))
                  {
                    // Set active item
                    let tray_items = this.parentElement.querySelectorAll(`div`);
                    if(tray_items !== undefined || tray_items.length > 0)
                    {
                      for(let i = 0; i < tray_items.length; i++)
                      {
                        if(tray_items[i].classList.contains('active'))
                        {
                          tray_items[i].click();
                        }
                      }
                    }
                  }
                  this.classList.toggle('active');
                  if(workspace !== null || typeof workspace == 'object')
                  {
                    workspace.querySelector('.dsb-workspace-overlay').classList.toggle('show');
                  }
                  e.detail.onclick();
                };

                //workspace.querySelector('.dsb-workspace-overlay').setAttribute('data-trayId',tray_id);
                workspace.querySelector('.dsb-workspace-overlay').onclick=function(){
                  //this.getAttribute('data-trayId')
                  let tray_items = document.getElementById(tray_id).parentElement.querySelectorAll(`div`);
                  if(tray_items !== undefined || tray_items.length > 0)
                  {
                    for(let i = 0; i < tray_items.length; i++)
                    {
                      console.error(tray_items[i]);
                      if(tray_items[i].classList.contains('active'))
                      {
                        tray_items[i].click();
                      }
                    }
                  }
                };
              }
              else
              {
                element.onclick = function(){e.detail.onclick()};
              }
              element.innerHTML = '<span style="padding-right:10px;">&nbsp;<span>';
              if(dom_insertion=='prepend')
              {
                document.getElementById(tray_id).prepend(element);
              }
              else
              {
                document.getElementById(tray_id).append(element);
              }
            }
            else if(('element' in e.detail) && e.detail.element instanceof HTMLElement)
            {
              if(dom_insertion=='prepend')
              {
                element.innerHTML = '<span style="padding-right:10px;">&nbsp;<span>';
                element.prepend(e.detail.element);
                document.getElementById(tray_id).prepend(element);
              }
              else
              {
                element.prepend(e.detail.element);
                document.getElementById(tray_id).append(element);
              }
            }
          }
          else
          {
            console.error('dsb-pwa-append_tray:: Missing any detail',e);
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-append_tray:: Error occured in detail',ex,e);
        }
     });

     window.addEventListener("dsb-pwa-trigger_tray", e => {
        try
        {
          if('detail' in e)
          {
            let tray_id = 'dsb-pwa_tray';
            if(('tray_id' in e.detail))
            {
              tray_id = "dsb-pwa_tray__"+e.detail.tray_id;
            }
            if(('name' in e.detail))
            {
              let target_element=document.getElementById(tray_id+"__"+e.detail.name);
              if(('metadata' in e.detail))
              {
                target_element.setAttribute('data-metadata',JSON.stringify(e.detail.metadata));
              }
              else
              {
                target_element.removeAttribute('data-metadata');
              }
              if(('append_location' in e.detail))
              {
                target_element.setAttribute('data-append_location',e.detail.append_location);
              }
              else
              {
                target_element.removeAttribute('data-append_location');
              }
              target_element.click();

            }
            else
            {
                console.error('dsb-pwa-trigger_tray:: No name supplied?');
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-trigger_tray:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-update_tray", e => {
        try
        {
          if('detail' in e)
          {
            let tray_id = 'dsb-pwa_tray';
            if(('name' in e.detail))
            {
              let target_element=document.getElementById(e.detail.name+"_aside_"+tray_id);
              if(target_element && ('attributes' in e.detail))
              {
                for( let att_key in e.detail.attributes)
                {
                  let value = e.detail.attributes[att_key];
                  if(typeof value === 'object')
                  {
                    value=JSON.stringify(value);
                  }

                  if(value.length==0)
                  {
                    if(target_element.hasAttribute('data-append_location'))
                    {
                      target_element.removeAttribute('data-append_location')
                    }
                  }
                  else
                  {
                    target_element.setAttribute('data-'+att_key,value);
                    console.error('dsb-pwa-update_tray:: updating',att_key,value);
                  }
                }
              }
            }
            else
            {
                console.error('dsb-pwa-update_tray:: '+e.detail.name+"_aside_"+tray_id+' doesnt exist or no name supplied?');
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-update_tray:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-toggle_full_screen", e => {
        try
        {
          if('detail' in e)
          {
            if(('source_id' in e.detail))
            {
              let elem = document.getElementById(e.source_id);
              if (elem.requestFullscreen) {
                elem.requestFullscreen();
              } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
              } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
              }
            }
            else
            {
              console.error('dsb-pwa-toggle_full_screen:: detail.source_id missing');
            }
          }
          else
          {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { /* Safari */
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE11 */
              document.msExitFullscreen();
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-toggle_full_screen:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-toggle_furniture", e => {
        try
        {
          if('detail' in e)
          {
            if(('target' in e.detail))
            {
              let app = window.fw_workbench.getApp();
              switch(e.detail.target)
              {
                case "tabs":
                  let show = false;
                  if(!app.classList.contains('focus'))
                  {
                    app.classList.add('focus');
                  }
                  if(('show' in e.detail))
                  {
                    if(e.detail.show)
                    {
                      show=true
                    }
                  }
                  else
                  {
                    if(app.classList.contains('tabs-off'))
                    {
                      show=true;
                    }
                  }

                  if(show)
                  {
                    if(app.classList.contains('tabs-off'))
                    {
                      app.classList.remove('tabs-off');
                    }
                    if(!app.classList.contains('tabs-on'))
                    {
                      app.classList.add('tabs-on');
                    }
                  }
                  else
                  {
                    if(app.classList.contains('tabs-on'))
                    {
                      app.classList.remove('tabs-on');
                    }
                    if(!app.classList.contains('tabs-off'))
                    {
                      app.classList.add('tabs-off');
                    }
                  }
                  _this._log('log','dsb-pwa-toggle_furnature',{'target':e.detail.target,"show":show});
                  break;
                default:
                  _this._log('error','dsb-pwa-toggle_furnature','Unknown target '+e.detail.target);
                  break;
              }
            }
            else
            {
              console.error('dsb-pwa-toggle_furnature:: detail.target missing');
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-toggle_furnature:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-add_modal", e => {
        try
        {
          if('detail' in e)
          {
            if(!('id' in e.detail))
            {
              e.detail.id=_this._createUUID();
            }
            let zindex = false;
            if(('iam' in e.detail))
            {
              zindex = window.getZIndex(e.detail.iam);
            }


            let element = document.createElement('dsb-modal');
            element.id = 'dsb-add_modal__'+e.detail.id;

            let workspace = document.createElement("dsb-workspace");
            let html = `
            <header>
              <ul>
                <li class="title"></li>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="tray" id="dsb-pwa_tray__`+e.detail.id+`">
                  <div id="dsb-pwa_tray_close__`+e.detail.id+`" class="m-icon-close icon-clickable" style="margin-left: 0px;font-size: 25px;">
                    <span style="padding-right:10px;">&nbsp;<span></span></span>
                  </div>
                </li>
              </ul>
            </header>`;
            if('content' in e.detail)
            {
              if(e.detail.content instanceof HTMLElement)
              {
                if(e.detail.content.tagName == 'DSB-WORKSPACE')
                {
                  workspace = e.detail.content;
                }
                else
                {
                  workspace.append(e.detail.content);
                }
              }
              else
              {
                  workspace.innerHTML = e.detail.content;
              }
            }

            var overlay = document.createElement("div");
            overlay.setAttribute(`class`,"dsb-workspace-overlay");
            workspace.append(overlay);

            element.innerHTML = html;
            element.append(workspace);
            this.append(element);

            if(zindex)
            {
              element.style.zIndex = zindex+1;
            }

            document.getElementById(`dsb-pwa_tray_close__`+e.detail.id+``).onclick = function(){
              document.getElementById(element.id).classList.toggle('show');
              // Reset app title
              _this._update_DocumentTitle('');
            };

            this.add_feedback('dsb-pwa_tray__'+e.detail.id);
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-add_modal:: Error occured in detail',ex);
        }
     });

     window.addEventListener("fw-workspace-check_for_update", async e => {
        try
        {
          let is_offline = await this.dsbClient.user.is_offline(false,true);
          if(('app_hash_url' in _this.setting) && ('app_hash' in _this.setting)  && ('app_name' in _this) && !is_offline)
          {
            if(!_this._shown_update_available)
            {
              let didTimeOut = false;
              const timeout = setTimeout(function() {
                  didTimeOut = true;
                  reject(new Error('Request timed out @'+_this.setting.app_hash_url));
              }, 5000);

              fetch(_this.setting.app_hash_url+'#sw:no-cache')
              .then(function(response) {
                  // Clear the timeout as cleanup
                  clearTimeout(timeout);

                  if(!didTimeOut) {
                      if(response.ok)
                      {
                        response.json().then(hash =>
                        {
                            if(hash !== null && typeof hash === 'object' && _this.app_name in hash && 'hash' in hash[_this.app_name])
                            {
                              let has_update = false;
                              if(hash[_this.app_name].hash !== _this.setting.app_hash)
                              {
                                has_update=true;
                                _this._log('info','event:fw-workspace-check_for_update','New update found',{"my_hash":_this.setting.app_hash,"your_hash":hash[_this.app_name].hash});
                              }
                              else
                              {
                                _this._log('info','event:fw-workspace-check_for_update','No updates',{"my_hash":_this.setting.app_hash,"your_hash":hash[_this.app_name].hash});
                              }

                              if(false)
                              {
                                let update_indicator = document.getElementById('fw_workspace__update_indicator');
                                if(update_indicator!==null &&  typeof update_indicator === 'object' && update_indicator instanceof HTMLElement)
                                {
                                  if(has_update)
                                  {
                                    update_indicator.style.setProperty('--flash-color_from','#4a4a4a');
                                    update_indicator.style.setProperty('--flash-color_to','#d2222a');
                                    update_indicator.classList='m-icon-update icon-clickable flash-color';
                                  }
                                  else
                                  {
                                    update_indicator.classList='icon-refresh icon-clickable';
                                  }
                                }
                              }

                              if(has_update)
                              {
                                _this._shown_update_available=true;
                                window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'New version available <button onclick="window.location.reload(true);">Update now</button>','icon':'m-icon-system-update','action':'hold','target':'header'}}));
                              }

                            }
                            else
                            {
                              _this._log('error','event:fw-workspace-check_for_update','Response for fetch('+_this.setting.app_hash_url+') malformed!',hash);
                            }
                        });

                      }
                      else
                      {
                          _this._log('error','event:fw-workspace-check_for_update','Response for fetch('+_this.setting.app_hash_url+') error!',response);
                      }
                  }
              })
              .catch(function(err) {
                  _this._log('error','event:fw-workspace-check_for_update','fetch failed! ', err);
                  window.dispatchEvent(new CustomEvent('fw-workspace-offline_status'));
                  // Rejection already happened with setTimeout
                    clearTimeout(timeout);
                  if(didTimeOut) return;
                  // Reject with error
                  reject(err);
              });
            }
          }
          else
          {
            _this._log('warn','event:fw-workspace-check_for_update','Update checking off, no app_hash_url, app_hash found! or your offline?',{'settings':_this.setting,'offline':is_offline});
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-check_for_update','Unexpected error', ex);
        }
     });

     window.addEventListener("fw-workspace-offline_status",async e => {
        let _this = this;
        try
        {
          let state = false;
          if('detail' in e && e.detail!==null)
          {
            state = e.detail;
          }
          else
          {
            state = await this.dsbClient.user.is_offline(false,true);
          }

          if(state)
          {
            if(!_this.get_store('has_offline_message',false))
            {
              let offline_refresh = document.createElement('button');
              offline_refresh.innerHTML='Try again';
              offline_refresh.onclick=function(){
                window.dispatchEvent(new CustomEvent('fw-workspace-offline_status'));
              }
              window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Offline mode','message_append':offline_refresh,'icon':'m-icon-offline','action':'hold','target':'header','callback__onload':function(){_this.set_store('has_offline_message',true);}}}));
            }
          }
          else
          {
            _this.set_store('has_offline_message',false);
            window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'clear':true,'target':'header'}}));
          }


          let offline_element = document.getElementsByClassName('fw_workspace__offline_indicator');
          for (var i = 0; i < offline_element.length; i++)
          {
            if(offline_element[i] && offline_element[i] instanceof HTMLElement)
            {
              if('detail' in e)
              {
                if(state)
                {
                  offline_element[i].style.display = 'inline-block';
                }
                else
                {
                  offline_element[i].style.display = 'none';
                }
              }
            }
          }
          offline_element = document.getElementsByClassName('fw_workspace__online_only');
          for (var i = 0; i < offline_element.length; i++)
          {
            if(offline_element[i] && offline_element[i] instanceof HTMLElement)
            {
              if('detail' in e)
              {
                let toggleClass = offline_element[i].getAttribute('data-offlineonly_toggleClass');
                if(state)
                {
                  if('onclick' in offline_element[i])
                  {
                    offline_element[i]._fw_workspace__online_only__onclick=offline_element[i].onclick;
                    offline_element[i].onclick=function(){
                      window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Sorry, your currently offline','icon':'error','action':'auto_close-2000'}}));
                    };
                    if(!offline_element[i].classList.contains(toggleClass))
                    {
                      offline_element[i].classList.add(toggleClass);
                    }
                  }
                }
                else
                {
                  if('_fw_workspace__online_only__onclick' in offline_element[i])
                  {
                    offline_element[i].onclick=offline_element[i]._fw_workspace__online_only__onclick;
                    if(offline_element[i].classList.contains(toggleClass))
                    {
                      offline_element[i].classList.remove(toggleClass);
                    }
                  }
                  if('refresh' in offline_element[i] && typeof offline_element[i].refresh == 'function')
                  {
                    offline_element[i].refresh();
                  }
                }
              }
            }
          }


        }
        catch(ex)
        {
          console.error('fw-workspace-offline_status:: Error occured in detail',ex);
        }
     });

     window.addEventListener("fw-workspace-trigger_message", e => {
        try
        {
          if('detail' in e)
          {
            let message_panel_target = window.fw_workbench.getApp();

            let stack_id = 'fw_workspace__message_stack';
            if(('target' in e.detail))
            {
              stack_id = 'fw_workspace__'+e.detail.target+'_message_stack';
            }

            let message_panel = document.getElementById(stack_id);

            if(('clear' in e.detail && e.detail.clear == true) || (stack_id == 'fw_workspace__header_message_stack'))
            {
              let default_headerHeight = getComputedStyle(message_panel_target).getPropertyValue('--fwwb-header-default-height');
              message_panel_target.style.setProperty('--fwwb-header-height',default_headerHeight);
              message_panel_target.style.setProperty('--fwwb-header-offset','0px');
              message_panel_target._toggleBackgroundColor();
              if((message_panel instanceof HTMLUListElement))
              {
                message_panel.remove();
                message_panel=null;
              }
            }

            if('message' in e.detail)
            {
              if(!(message_panel instanceof HTMLUListElement))
              {
                message_panel = document.createElement('ul');
                message_panel.id=stack_id;
                message_panel_target.append(message_panel);
                message_panel.style.zIndex = '9999999999999999999999999999999999999999999999999999';
              }


              let message_panel_li = document.createElement("li");
              let message_panel_li_icon = document.createElement("span");
              let message_panel_li_body = document.createElement("span");
              let message_panel_li_close = document.createElement("span");
              message_panel_li_close.classList='icon-close';

              let icon = 'icon-info-outline';
              let callback__onload=function(){};
              if('callback__onload' in e.detail && typeof e.detail.callback__onload == 'function')
              {
                callback__onload=e.detail.callback__onload
              }

              if('icon' in e.detail)
              {
                switch(e.detail.icon)
                {
                  case "done":
                      message_panel_li_icon.classList='icon-check-circ';
                      message_panel_li.classList.add('done');
                      break;
                  case "error":
                       message_panel_li_icon.classList='icon-warning-outline';
                      message_panel_li.classList.add('error');
                      break;
                  default:
                     message_panel_li_icon.classList=e.detail.icon;
                    break;
                }
              }
              message_panel_li_body.innerHTML=e.detail.message;

              if('message_append' in e.detail)
              {
                if(e.detail.message_append instanceof HTMLElement)
                {
                  message_panel_li_body.append(e.detail.message_append);
                }
              }
              message_panel_li.append(message_panel_li_icon);
              message_panel_li.append(message_panel_li_body);
              message_panel_li.append(message_panel_li_close);

              //message_panel_li.innerHTML='<span class="'+icon+'"></span><span>'+e.detail.message+'</span><span class=""></span>';
              message_panel.append(message_panel_li);
              message_panel.style.display='inline-block';

              let fadeIn_function = function(){};
              if(stack_id !== 'fw_workspace__header_message_stack')
              {

                if(!('notifications' in this.messages))
                {
                  this.messages.notifications = [];
                }

                let message_id = this.messages.notifications.length-1;
                if(message_id<0)
                {
                  message_id=0;
                }
                /**
                if(this.messages.notifications[message_id] instanceof HTMLElement)
                {
                    message_panel_li.style.top=(parseInt(window.getComputedStyle(this.messages.notifications[message_id]).getPropertyValue('top').replace('px',''))+parseInt(window.getComputedStyle(this.messages.notifications[message_id]).getPropertyValue('height').replace('px',''))+15)+'px';
                }
                */
                message_panel_li.setAttribute('data-notification-no',message_id);


                message_panel_li.onclick=function()
                {
                  window.fw_workbench.fadeOut(message_panel_li,function(thisElement){
                    let message_id = thisElement.getAttribute('data-notification-no');
                    if(!isNaN(message_id))
                    {
                      let subtract=false;
                      for(let i=0; i<_this.messages.notifications.length;i++)
                      {
                        if(_this.messages.notifications[i] instanceof HTMLElement)
                        {
                          if(message_id == i)
                          {
                            //subtract=parseInt(window.getComputedStyle(_this.messages.notifications[i]).getPropertyValue('height').replace('px',''));
                            thisElement.remove();
                            _this.messages.notifications.splice(i, 1);
                            //console.error('@deleted',i, _this.messages.notifications);
                          }
                          /**
                          else
                          {
                            if(subtract)
                            {
                              let top = parseInt(window.getComputedStyle(_this.messages.notifications[i]).getPropertyValue('top').replace('px',''));
                              console.error('@3',i,subtract, top, _this.messages.notifications[i].style.top);
                              _this.messages.notifications[i].style.top = (top-Math.round(subtract));
                              console.error('@4',i,subtract, top, _this.messages.notifications[i].style.top,_this.messages.notifications);
                            }
                          }
                          */
                        }
                      }
                    }
                  });
                }

                this.messages.notifications.push(message_panel_li);

                if('action' in e.detail)
                {
                  switch(e.detail.action)
                  {
                    case "hold":
                      message_panel_li.onclick='';
                      break;
                    default:
                      if(e.detail.action.startsWith('auto_close-'))
                      {
                      let seconds = parseInt(e.detail.action.replace('auto_close-',''));
                      if(!isNaN(seconds))
                      {
                        fadeIn_function=function(thisElement){
                            callback__onload();
                            setTimeout(function(){
                              thisElement.click();
                            },seconds);
                          }
                      }
                      }
                      break;
                  }
                }
              }
              else
              {
                fadeIn_function=function(thisElement){

                    message_panel_target._toggleBackgroundColor(getComputedStyle(thisElement).backgroundColor);
                    let current_headerHeight = getComputedStyle(window.fw_workbench.getApp()).getPropertyValue('--fwwb-header-default-height');
                    let current_messageHeight = getComputedStyle(thisElement).height;
                    if(!current_messageHeight)
                    {
                      current_messageHeight = '0px';
                    }
                    message_panel_target.style.setProperty('--fwwb-header-height','calc('+current_headerHeight+' + '+current_messageHeight+')');
                    message_panel_target.style.setProperty('--fwwb-header-offset',current_messageHeight);
                    callback__onload();

                }
              }


              window.fw_workbench.fadeIn(message_panel_li,fadeIn_function);

            }
            else
            {
              _this._log('error','event:fw-workspace-trigger_message','e.detail.message missing');
            }


          }
          else
          {
            _this._log('error','event:fw-workspace-trigger_message','e.detail is missing');
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-trigger_message','General error has occured',ex);
        }
     });

     window.addEventListener("fw-workspace-trigger_event", e => {
        try
        {
          if('detail' in e && 'event' in e.detail)
          {
              switch(e.detail.event)
              {

                default:
                  this._log('debug','fw-workspace-trigger_event','Not done anything with '+e.detail.event+' event...');
                  break;
              }
          }
          else
          {
            _this._log('error','event:fw-workspace-trigger_event','e.detail is missing');
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-trigger_event','General error has occured',ex);
        }
     });


     /**
     window.addEventListener("fw-workspace-set_header_overlay", e => {
        try
        {
          if('detail' in e)
          {
            let app = window.fw_workbench.getApp();
            let header = app.querySelector('header');
            let uls = app.querySelectorAll('ul');
            let function__reset = function(){
              if(uls.length > 1)
              {
                for(let i=1; i<uls.length; i++)
                {
                  uls[i].remove();
                }
                uls[0].style.display='grid';
              }
              else
              {
                _this._log('warning','event:fw-workspace-set_header_overlay',{'message':'uls not greater than 1','uls':uls,'header':header});
              }
            }
            if('reset' in e.detail)
            {
                function__reset();
            }
            else
            {
              console.error('@set_header_overlay-1');

              let action =false;
              let new_header_ul = document.createElement('ul');
              let right_li = document.createElement('li');
              if('right_items' in e.detail && Array.isArray(e.detail.list_items))
              {
                for(let i=0; i<e.detail.list_items.length; i++)
                {
                  if(e.detail.list_items[i] instanceof HTMLElement)
                  {
                    right_li.append(e.detail.list_items);
                    action=true;
                  }
                  else
                  {
                    console.error('dsb-pwa-set_header_overlay:: detail.right_li[i] not HTMLElement',e);
                  }
                }
              }
              let left_li = document.createElement('li');
              if('left_items' in e.detail && Array.isArray(e.detail.list_items))
              {
                for(let i=0; i<e.detail.list_items.length; i++)
                {
                  if(e.detail.list_items[i] instanceof HTMLElement)
                  {
                    left_li.append(e.detail.list_items);
                    action=true;
                  }
                  else
                  {
                    console.error('dsb-pwa-set_header_overlay:: detail.left_li[i] not HTMLElement',e);
                  }
                }
              }
              if(action)
              {
                new_header_ul.append(left_li);
                new_header_ul.append(right_li);
                uls[0].style.display='none';
                header.append(new_header_ul);
              }
              console.error('@set_header_overlay-4',app,new_header);
            }
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-set_header_overlay','General error has occured',ex);
        }
     });
     window.addEventListener("fw-workspace-toggle_header_overlay", e => {
        try
        {
          let new_header = document.getElementById('fw-workspace-header_overlay');
          if((new_header instanceof HTMLLIElement))
          {
            if(new_header.style.display == 'none')
            {
              console.error('@toggle_header_overlay-fadeIn');
              window.fw_workbench.fadeIn(new_header);
            }
            else
            {
              console.error('@toggle_header_overlay-fadeOut');
              window.fw_workbench.fadeOut(new_header,function(i){
              i.remove();
               console.error('@toggle_header_overlay-fadeOut');
              });
            }
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-set_header_overlay','General error has occured',ex);
        }
     });
     */

     window.addEventListener("fw-workspace-add_swipe_interaction", e => {
        try
        {
          if('detail' in e)
          {
            let target = null;
            if(('iam' in e.detail))
            {
              let hasSwipe=false;
              let swipe_container_left = false;
              let swipe_container_right = false;
              let swipe_container_innerhtml = document.createElement("div");
              swipe_container_innerhtml.innerHTML =  target.innerHTML;

              if(('left' in e.detail)
                && ('message' in e.detail.left)
                && ('font_icon' in e.detail.left)
                && ('action' in e.detail.left)
                && typeof e.detail.left.action == 'function')
              {
                hasSwipe=true;
                swipe_container_left = document.createElement("div");
                swipe_container_left.innerHTML = '<i style="color: white;position: sticky;left: 16px;right: 16px;" class="'+e.detail.left.font_icon+'">'+e.detail.left.message+'</i>';
                swipe_container_left.style='background-color: orchid;';
                swipe_container_left.onclick = function(){
                  console.error('Left swipe');
                }
                swipe_container.append(swipe_container_left);
              }

              let swipe_container = document.createElement("div");
              swipe_container.style = ' display: flex;overflow: auto;overflow-x: scroll;scroll-snap-type: x mandatory;';
              swipe_container.append(swipe_container_innerhtml);

              if(('right' in e.detail)
                && ('message' in e.detail.right)
                && ('font_icon' in e.detail.right)
                && ('action' in e.detail.right)
                && typeof e.detail.right.action == 'function')
              {
                hasSwipe=true;
                swipe_container_right = document.createElement("div");
                swipe_container_right.innerHTML = '<i style="color: white;position: sticky;left: 16px;right: 16px;" class="'+e.detail.right.font_icon+'">'+e.detail.right.message+'</i>';
                swipe_container_right.style='justify-content: flex-end;background-color: cornflowerblue;';
                swipe_container_right.onclick = function(){
                  console.error('Right swipe');
                }
                swipe_container.append(swipe_container_right);
              }

              if(hasSwipe)
              {
                swipe_container.ontouchend = function() {
                  // define the minimum distance to trigger the action
                  const minDistance = 80;

                  // get the distance the user swiped
                  const swipeDistance = this.scrollLeft - this.clientWidth;
                  console.error('left:'+this.scrollLeft+', clientWidth:'+this.clientWidth+', swipeDistance:'+swipeDistance);
                  if (swipeDistance < minDistance * -1) {
                    if(swipe_container_left)
                    {
                      swipe_container_left.onclick();
                    }
                    console.error('left swipe');
                  } else if (swipeDistance > minDistance) {
                    if(swipe_container_right)
                    {
                      swipe_container_right.onclick();
                    }
                    console.error('right swipe');
                  } else {
                    console.error('no swipe');
                  }
                }
                target.innerHTML = '';
                e.detail.iam.append(swipe_container);
              }
            }
            else
            {
              _this._log('error','event:fw-workspace-add_swipe_interaction','e.detail.iam missing');
            }
          }
          else
          {
            _this._log('error','event:fw-workspace-add_swipe_interaction','e.detail is missing');
          }
        }
        catch(ex)
        {
          _this._log('error','event:fw-workspace-add_swipe_interaction','General error has occured',ex);
        }
     });

     window.addEventListener("dsb-pwa-transient_modal", e => {
        try
        {
          if('detail' in e)
          {
            if(('content' in e.detail) && e.detail.content instanceof HTMLElement)
            {

              let feedback__append_location='';
              let hide = [];
              if('hide' in e.detail)
              {
                hide = e.detail.hide;
              }

              let logo = '';
              if('show_logo' in e.detail)
              {
                logo = `<a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a>`;
              }

              let id = _this._createUUID();
              let modal = document.createElement('dsb-modal');
              modal.id = 'dsb-add_modal__'+id;

              let template = '';
              if('template' in e.detail)
              {
                template = e.detail.template;
              }

              switch(template)
              {
                case "two_tray":
                   modal.innerHTML = `
                  `+(hide.indexOf('header')<0?`
                  <header>
                    <ul class="two_tray">
                      <li class="tray_left" id="dsb-pwa_tray_left__`+id+`">
                      `+(hide.indexOf('close')<0?`
                        <div id="dsb-pwa_tray_close__`+id+`" class="m-icon-back icon-clickable" style="margin-left: 0px;font-size: 26px;">
                        </div>
                        `:'')+`
                      </li>
                      <li class="tray" id="dsb-pwa_tray__`+id+`">
                        `+(hide.indexOf('refresh')<0?`
                        <div id="dsb-pwa_tray_rebuild__`+id+`" class="icon-refresh icon-clickable" style="margin-left: 0px;font-size: 25px;">
                          <span style="padding-right:0px;">&nbsp;<span></span></span>
                        </div>
                        `:'')+`
                      </li>
                    </ul>
                  </header>
                  `:'')+`
                  <dsb-workspace></dsb-workspace>
                  `;
                  break;
                default:
                   modal.innerHTML = `
                    `+(hide.indexOf('header')<0?`
                    <header>
                      <ul>
                        <li class="title">`+logo+`</li>
                        <li class="logo"></li>
                        <li class="tray" id="dsb-pwa_tray__`+id+`">
                          `+(hide.indexOf('refresh')<0?`
                          <div id="dsb-pwa_tray_rebuild__`+id+`" class="icon-refresh icon-clickable" style="margin-left: 0px;font-size: 25px;">
                            <span style="padding-right:0px;">&nbsp;<span></span></span>
                          </div>
                          `:'')+`
                          `+(hide.indexOf('close')<0?`
                          <div id="dsb-pwa_tray_close__`+id+`" class="m-icon-close icon-clickable" style="margin-left: 0px;font-size: 25px;">
                            <span style="padding-right:10px;">&nbsp;<span></span></span>
                          </div>
                          `:'')+`
                        </li>
                      </ul>
                    </header>
                    `:'')+`
                    <dsb-workspace></dsb-workspace>
                    `;
                  break;
              }


              this.append(modal);

              if('action' in e.detail && e.detail.action == 'refresh')
              {
                document.getElementById(`dsb-pwa_tray_rebuild__`+id+``).className='icon-refresh icon-rotate icon-clickable';
              }

              let workspace = modal.querySelector('dsb-workspace');
              if(workspace != null && typeof workspace === 'object')
              {
                var overlay = document.createElement("div");
                overlay.setAttribute(`class`,"dsb-workspace-overlay");
                workspace.innerHTML = ``;
                workspace.append(overlay);
                workspace.append(e.detail.content);

                if(e.detail.content != null && typeof e.detail.content === 'object' && `service` in e.detail.content && `post_id` in e.detail.content)
                {
                  feedback__append_location='/'+e.detail.content.service+'/'+e.detail.content.post_id;
                }

                let feedback_aside_iframe=document.getElementById("feedback_aside_dsb-pwa_tray__"+id);
                if(feedback_aside_iframe != null && typeof feedback_aside_iframe === 'object')
                {
                  if(e.detail.content != null && typeof e.detail.content === 'object' && `link_path` in e.detail.content && e.detail.content.link_path != null)
                  {
                    feedback__append_location='/modal/'+e.detail.content.link_path;
                    feedback_aside_iframe.setAttribute('data-append_location','/modal/'+e.detail.content.link_path);
                    console.log('Updating feedback_aside data-append_location to /modal/'+e.detail.content.link_path);
                  }
                }
              }
              else
              {
                throw "workspace missing for modal "+modal.id;
              }

              if(hide.indexOf('close')<0)
              {
                document.getElementById(`dsb-pwa_tray_close__`+id+``).onclick = async function(){

                  let done_function = function(){
                    // Reset app title
                    _this._update_DocumentTitle('');
                    // Delete Modal
                    modal.outerHTML="";
                  }

                  // Call close event on content (if it has one)
                  if('transient_modal__close' in e.detail.content && typeof e.detail.content.transient_modal__close == 'function')
                  {
                    await e.detail.content.transient_modal__close(done_function);
                  }
                  else
                  {
                    done_function();
                  }

                };
              }

              if(hide.indexOf('refresh')<0)
              {
                document.getElementById(`dsb-pwa_tray_rebuild__`+id+``).onclick = function(){
                  // Reset app title
                  _this._update_DocumentTitle('');
                  // Delete Modal
                  modal.outerHTML="";
                  // Rebuild
                  if('reset' in e.detail.content && typeof e.detail.content.reset == 'function')
                  {
                    e.detail.content.reset();
                  }
                  else
                  {
                    e.detail.content.innerHTML = '';
                  }
                  window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:e.detail.content,action:'refresh',hide:hide,template:template}}));
                };
              }

              if(hide.indexOf('feedback')<0)
              {
                this.add_feedback('dsb-pwa_tray__'+id,{'append_location':feedback__append_location});
              }

              if(!modal.classList.contains('show'))
              {
                if('action' in e.detail && e.detail.action == 'refresh')
                {
                  // Ok, do nothing
                }
                else
                {
                  if('mode' in e.detail)
                  {
                    modal.classList.add(e.detail.mode);
                  }
                  else
                  {
                    modal.classList.add('fadeIn');
                  }
                }
                modal.classList.toggle('show');
              }

            }
            else
            {
              throw "Missing detail.content or not instanceof HTMLElement... nothing to do!";
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-add_modal:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-pwa-trigger_modal", e => {
        try
        {
          if('detail' in e)
          {
            if(('id' in e.detail))
            {
              let modal = document.getElementById('dsb-add_modal__'+e.detail.id);
              if(modal != null)
              {
                if(('append' in e.detail))
                {
                  let workspace = modal.querySelector('dsb-workspace');
                  if(workspace != null && typeof workspace === 'object')
                  {
                    let overlay = workspace.querySelector('.dsb-workspace-overlay');
                    workspace.innerHTML = ``;
                    workspace.append(overlay);
                    workspace.append(e.detail.append);
                    let feedback_aside_iframe=document.getElementById("feedback_aside_dsb-pwa_tray__"+e.detail.id);
                    if(feedback_aside_iframe != null && typeof feedback_aside_iframe === 'object')
                    {
                      if(e.detail.append != null && typeof e.detail.append === 'object' && `link_path` in e.detail.append && e.detail.append.link_path != null)
                      {
                        feedback_aside_iframe.setAttribute('data-append_location','/modal/'+e.detail.append.link_path);
                        console.log('Updating feedback_aside data-append_location to /modal/'+e.detail.append.link_path);
                      }
                    }
                  }
                }

                if(!modal.classList.contains('show'))
                {
                  modal.classList.toggle('show');
                }
              }
            }
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-trigger_tray:: Error occured in detail',ex);
        }
     });

     window.addEventListener("dsb-app-throwError", e => {

        let _type = '';
        if('type' in e)
        {
            _type = e.type;
        }

        let _message = '';
        if('message' in e)
        {
            _message = e.message;
        }

        switch(_type)
        {
          default:
            console.error(message);
            break;
        }
     });

     window.addEventListener("dsb-pwa-throwError", e => {

        if('detail' in e)
        {
          let _type = '';
          if('type' in e.detail)
          {
              _type =  e.detail.type;
          }

          let _message = '';
          if('message' in e.detail)
          {
              _message = e.detail.message;
          }

          console.error('Error: Type='+_type,_message);

          switch(_type)
          {
            default:
              break;
          }
        }
        else
        {
          console.error(e);
        }
     });

      window.addEventListener("dsb-pwa-add_pulldown_refresh", e => {
        try
        {
          if('detail' in e)
          {

            if('iam' in e.detail)
            {
              if(typeof e.detail.iam == 'object' && e.detail.iam )
              {
                let _this = e.detail.iam;

                if('_refresh' in _this && typeof _this._refresh == 'function')
                {
                  const pStart = { x: 0, y: 0 };
                  const pCurrent = { x: 0, y: 0 };

                  let refresh_panel_target = false;
                  let refresh_panel = document.createElement("div");
                  refresh_panel.classList='pulldown-refresh';
                  refresh_panel.innerHTML = `<maa-spinner type="inline-small"></maa-spinner>`;

                  console.debug('dsb-pwa-add_pulldown_refresh:: Setting up',_this);

                  let loadPulldown = async function() {
                    // Find workspace
                    if(!refresh_panel_target)
                    {
                      refresh_panel_target = window.getWorkspace(_this);
                      if(!(refresh_panel_target instanceof HTMLElement))
                      {
                        refresh_panel_target = _this;
                      }
                    }
                    // Pulldown refresh
                    if(!(refresh_panel_target.querySelector('.pulldown-refresh') instanceof HTMLElement))
                    {
                      console.debug('dsb-pwa-add_pulldown_refresh:: Adding pulldown_refresh panel',_this);
                      refresh_panel.classList='pulldown-refresh';
                      refresh_panel_target.prepend(refresh_panel);
                    }

                    if(refresh_panel.classList.contains('hide'))
                    {
                      refresh_panel.classList='pulldown-refresh';
                    }

                    if(!refresh_panel.classList.contains('show'))
                    {
                      console.debug('dsb-pwa-add_pulldown_refresh:: Refreshing...',_this);
                      refresh_panel.classList.add('show');
                      let _refresh = await _this._refresh();
                      refresh_panel.classList.remove('show');
                      refresh_panel.classList.add('hide');
                    }
                    else
                    {
                      console.error('do nothing...');
                    }
                  };
                  _this.addEventListener("touchstart", e => {
                    try
                    {
                      if (typeof e["targetTouches"] !== "undefined") {
                        let touch = e.targetTouches[0];
                        pStart.x = touch.screenX;
                        pStart.y = touch.screenY;
                      } else {
                        pStart.x = e.screenX;
                        pStart.y = e.screenY;
                      }
                    }
                    catch(ex)
                    {
                      console.error('DSBWorkspace-touchstart:: Error occured in detail',ex,e);
                    }
                  });
                  _this.addEventListener("touchmove", e => {
                    try
                    {
                      if (typeof e["changedTouches"] !== "undefined") {
                        let touch = e.changedTouches[0];
                        pCurrent.x = touch.screenX;
                        pCurrent.y = touch.screenY;
                      } else {
                        pCurrent.x = e.screenX;
                        pCurrent.y = e.screenY;
                      }
                      let changeY = pStart.y < pCurrent.y ? Math.abs(pStart.y - pCurrent.y) : 0;
                      if (_this.scrollTop === 0) {
                        if (changeY > 100) loadPulldown();
                      }
                    }
                    catch(ex)
                    {
                      console.error('dsb-pwa-add_pulldown_refresh:: Error occured in detail',ex,e);
                    }
                  });
                  _this.addEventListener("touchend", e => {
                    try
                    {
                      if (_this.scrollTop === 0 && !refresh_panel) {
                        console.error('Ok.. at top and no loading...');
                      }
                    }
                    catch(ex)
                    {
                      console.error('DSBWorkspace-touchend:: Error occured in detail',ex,e);
                    }
                  });
                }
                else
                {
                  throw "e.detail.iam needs to expose a '_refresh' function";
                }
              }
              else
              {
                throw "e.detail.iam should be instanceof HTMLElement";
              }
            }
            else
            {
              throw "e.detail.iam missing";
            }
          }
          else
          {
            throw "e.detail missing";
          }
        }
        catch(ex)
        {
          console.error('dsb-pwa-add_pulldown_refresh:: Error occured in detail',ex);
        }
      });


      window.fw_workbench = {};

      window.fw_workbench.getAppStyleProperties = function (type,property)
      {
        switch(type)
        {
          case "app":
              return getComputedStyle(document.querySelector('dsb-app'))[property];
          case "header":
              return getComputedStyle(document.querySelector('dsb-app > header'))[property];
          case "nav":
              return getComputedStyle(document.querySelector('dsb-app > nav'))[property];
          case "workspace":
              return getComputedStyle(document.querySelector('dsb-app > dsb-workspace'))[property];
          default:
              break;
        }
        return false;
      }

      window.fw_workbench.getApp = function ()
      {
        let app = document.querySelector('dsb-app');
        if(app != null && typeof app === 'object' && app instanceof HTMLElement)
        {
          return app;
        }
        return false;
      }

      // thanks to Craig Buckler: https://www.sitepoint.com/javascript-generate-lighter-darker-color/
      window.fw_workbench.getColorLuminance = function(hex, lum){

        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
          hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
        }
        lum = lum || 0;

        // convert to decimal and change luminosity
        var rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
          c = parseInt(hex.substr(i*2,2), 16);
          c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
          rgb += ("00"+c).substr(c.length);
        }

        return rgb;
      };


      window.fw_workbench.pulse = function(element,to_color,callback=false) {
          var from_color = element.style.backgroundColor;  // initial opacity
          var count = 10;
          var timer = setInterval(function () {
              if (count <=1){
                  clearInterval(timer);
                  if(typeof callback == 'function')
                  {
                    callback(element);
                  }
              }
              element.style.opacity = op;
              element.style.filter = 'alpha(opacity=' + op * 100 + ")";
              count++;
          }, 10);
      }


      window.fw_workbench.fadeIn = function(element,callback=false) {
          var op = 0.1;  // initial opacity
          element.style.display = 'block';
          element.style.opacity = op;
          var timer = setInterval(function () {
              if (op >= 1){
                  clearInterval(timer);
                  if(typeof callback == 'function')
                  {
                    callback(element);
                  }
              }
              element.style.opacity = op;
              element.style.filter = 'alpha(opacity=' + op * 100 + ")";
              op += op * 0.1;
          }, 10);
      }

       window.fw_workbench.fadeOut = function(element, callback=false) {
          var op = 1;  // initial opacity
          var timer = setInterval(function () {
              if(op == 1)
              {
                  if('onclick' in element)
                  {
                      element.onclick = function(){};
                  }
              }
              if (op <= 0.1){
                  clearInterval(timer);
                  element.style.display = 'none';
                  if(typeof callback == 'function')
                  {
                    callback(element);
                  }
              }
              element.style.opacity = op;
              element.style.filter = 'alpha(opacity=' + op * 100 + ")";
              op -= op * 0.1;
          }, 50);
      }

      window.fw_workbench.smoothScroll = function(target,to=0)
      {
          var smoothScrollFeature = 'scrollBehavior' in document.documentElement.style;
          var i = parseInt(target.scrollTop);
          if ( i != to ) {
              if (!smoothScrollFeature) {
                  to = parseInt(to);
                  if (i < to) {
                      var int = setInterval(function() {
                          if (i > (to-20)) i += 1;
                          else if (i > (to-40)) i += 3;
                          else if (i > (to-80)) i += 8;
                          else if (i > (to-160)) i += 18;
                          else if (i > (to-200)) i += 24;
                          else if (i > (to-300)) i += 40;
                          else i += 60;
                          target.scroll(0, i);
                          if (i >= to) clearInterval(int);
                      }, 15);
                  }
                  else {
                      var int = setInterval(function() {
                          if (i < (to+20)) i -= 1;
                          else if (i < (to+40)) i -= 3;
                          else if (i < (to+80)) i -= 8;
                          else if (i < (to+160)) i -= 18;
                          else if (i < (to+200)) i -= 24;
                          else if (i < (to+300)) i -= 40;
                          else i -= 60;
                          target.scroll(0, i);
                          if (i <= to) clearInterval(int);
                      }, 15);
                  }
              }
              else {
                  target.scroll({
                      top: to,
                      behavior: 'smooth'
                  });
              }
          }
      };

      window.fw_workbench.getParentBySelector = function (selector,e) {
        let aParent = e.parentNode;
        if(aParent != null && typeof aParent === 'object')
        {
          let element = aParent.querySelector(selector);
          if(element != null && typeof element === 'object')
          {
            return element;
          }
          return window.fw_workbench.getParentBySelector(selector,aParent);
        }
        return false;
      };

      window.getZIndex = function (e) {
        var z = window.document.defaultView.getComputedStyle(e).getPropertyValue('z-index');
        if (isNaN(z)) return window.getZIndex(e.parentNode);
        return z;
      };

      window.getWorkspace = function (e) {
        let aParent = e.parentNode;
        if(aParent != null && typeof aParent === 'object')
        {
          let workspace = aParent.querySelector('dsb-workspace');
          if(workspace != null && typeof workspace === 'object')
          {
            return workspace;
          }
          return window.getWorkspace(aParent);
        }
        return false;
      };

      window.getTrayId = function (e,selector='.tray') {
        let aParent = e.parentNode;
        if(aParent != null && typeof aParent === 'object')
        {
          let tray = aParent.querySelector(selector);
          if(tray != null && typeof tray === 'object' && ('id' in tray && tray.id.startsWith('dsb-pwa_tray')))
          {
            return tray.id;
          }
          return window.getTrayId(aParent,selector);
        }
        return false;
      };

  }
